<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="bg-light shadow p-3 my-4 rounded" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="text-center my-5 " >
                <template #default>شارژ کیف پول   </template>
                </m-h4><m-wallet-1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-wallet-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mWallet1 from '@moeinmdn/miw-alpha-components/src/package/Wallet/Wallets/Wallet1/Wallet1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH4,mWallet1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
